import { setCookie } from "./cookiesHelper";

export const setUserRole = (plan: string) => {
	if (plan.includes("Procurer")) {
		setCookie("role", "client");
	} else if (plan.includes("Bidder")) {
		setCookie("role", "supplier");
	}
};
